import { combineEpics } from "redux-observable";
import { epicQuickSkipCancel } from "./epics/epicQuickSkipCancel";
import { epicQuickSkipConstructionSkip } from "./epics/epicQuickSkipConstructionSkip";
import { epicQuickSkipProductionSkip } from "./epics/epicQuickSkipProductionSkip";
export var epicQuickSkip = combineEpics(epicQuickSkipProductionSkip, epicQuickSkipConstructionSkip, epicQuickSkipCancel);



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/epicQuickSkip.ts
// module id = 2112
// module chunks = 3